// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SideBar_sidebar__3kKt6","activeroute":"SideBar_activeroute__Nr7Xj"};